export default __webpack_public_path__ + "static/media/industries-background.d8e5350f.svg";